import { createFileRoute } from '@tanstack/react-router'
import { RecurringListPage } from '../../../../features/finance/recurring-list-page'
import { recurringSearchSchema } from '../../../../features/finance/search'

export const Route = createFileRoute('/_app/expenses/recurring/')({
  validateSearch: recurringSearchSchema,
  component: RecurringListPage,
})
